// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Dp-z","badgeLink":"Ep-z","category":"Fp-z"};